export { OrderStatusLoyaltyPointsBanner } from './OrderStatusLoyaltyPointsBanner';
